/**
 * Tope de rango de los reportes del BO. Espeja
 * `worker-api/src/features/report/domain/constants/reportDateRange.ts`: el
 * backend valida igual, esto es para que el date picker no deje elegir un rango
 * que el servidor va a rechazar.
 */
export const REPORT_MAX_RANGE_MONTHS = 6;

export const REPORT_DATE_RANGE_HINT = `Podés consultar hasta ${REPORT_MAX_RANGE_MONTHS} meses por vez.`;

export const reportDateRangeExceededMessage = () =>
  `El rango de fechas no puede superar ${REPORT_MAX_RANGE_MONTHS} meses`;

export const addCalendarMonths = (date: Date, months: number): Date => {
  const result = new Date(date);
  result.setHours(0, 0, 0, 0);
  result.setMonth(result.getMonth() + months);
  return result;
};

export const isReportDateRangeWithinLimit = (dateFrom: Date, dateTo: Date): boolean =>
  dateTo.getTime() <= addCalendarMonths(dateFrom, REPORT_MAX_RANGE_MONTHS).getTime();

export const getMaxReportDateTo = (dateFrom: Date, capAt?: Date): Date => {
  const maxByRange = addCalendarMonths(dateFrom, REPORT_MAX_RANGE_MONTHS);
  if (!capAt) {
    return maxByRange;
  }
  return maxByRange.getTime() < capAt.getTime() ? maxByRange : capAt;
};

export const getMinReportDateFrom = (dateTo: Date): Date =>
  addCalendarMonths(dateTo, -REPORT_MAX_RANGE_MONTHS);

/**
 * `YYYY-MM-DD` en hora local, no en UTC.
 *
 * `toISOString().split('T')[0]` sobre un `Date` local en Argentina (UTC-3)
 * devuelve el día siguiente para cualquier hora a partir de las 21:00, así que
 * el rango que se manda no es el que el usuario eligió en el calendario.
 */
export const toReportDateParam = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
